import React, {useEffect, useState} from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/authContext";
import {useLocation} from "react-router";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box"; // Assuming you have an auth context

const ProtectedRoute = ({ children }) => {
    const { authenticated, token } = useAuth();
    const location = useLocation();
    const [isReady, setIsReady] = useState(false);

    useEffect(() => {
        const checkAuth = async () => {
            // Wait for next tick to ensure auth state is updated
            await new Promise(resolve => setTimeout(resolve, 1000));
            setIsReady(true);
        };
        checkAuth();
    }, [authenticated, token]);

    if (!isReady) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
                <CircularProgress />
            </Box>
        );
    }

    if (!authenticated) {
        return <Navigate to="/home" state={{ from: location }} replace />;
    }

    return children;
};

export default ProtectedRoute;